import { errorMessage } from "../lib/api";

export function Loading({ what = "Loading" }: { what?: string }) {
	return (
		<p className="py-10 text-center text-sm" style={{ color: "var(--color-ink-400)" }}>
			{what}…
		</p>
	);
}

export function LoadError({ error, retry }: { error: unknown; retry?: () => void }) {
	return (
		<div className="panel mx-auto my-10 max-w-md p-5 text-center">
			<p className="text-sm">{errorMessage(error)}</p>
			{retry && (
				<button type="button" className="btn mt-3" onClick={retry}>
					Try again
				</button>
			)}
		</div>
	);
}

export function PageHeader({ eyebrow, title, children }: { eyebrow?: React.ReactNode; title: React.ReactNode; children?: React.ReactNode }) {
	return (
		<header className="mb-6 flex flex-wrap items-end justify-between gap-4">
			<div className="min-w-0">
				{eyebrow && (
					<div className="mb-1 text-sm" style={{ color: "var(--color-ink-300)" }}>
						{eyebrow}
					</div>
				)}
				<h1 className="text-3xl leading-tight">{title}</h1>
			</div>
			{children && <div className="flex items-center gap-2">{children}</div>}
		</header>
	);
}
